/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import Row from '../tracking-list/row';
import { ScopeQuestionOptionalValue } from '../../types/surveyScope';
import { ColumnCode } from '../survey-question-list/partials/ColumnCode';
import { ColumnTitle } from '../survey-question-list/partials/ColumnTitle';
import { LazyLoadingTrackingList } from '../survey-question-list/partials/LazyLoadingTrackingList';
import { GroupQuestionListColumnProps, GroupQuestionListColumns } from './types';
import { QUESTION } from '../../constants/terminology';

const defaultColumns: GroupQuestionListColumns = [
  { header: () => <>Type code</>, component: ColumnCode },
  { header: () => <>{QUESTION.CAPITALIZED_SINGULAR}</>, component: ColumnTitle },
];

interface CombinedUtrsProps {
  columns?: GroupQuestionListColumns;
  questionGroupId: string;
  questionList: ScopeQuestionOptionalValue[];
  colour?: string;
  // @deprecated in favour of preferredAltCodes
  alternativeCode?: string;
  preferredAltCodes?: string[];
}

const highlightClass = 'highlight-blink';

const removeClass: React.MouseEventHandler<HTMLDivElement> = (e) => e.currentTarget.classList.remove(highlightClass);

export const GroupQuestionList = (props: CombinedUtrsProps) => {
  const { questionGroupId, colour, alternativeCode, preferredAltCodes, questionList } = props;

  const columns = props.columns ?? defaultColumns;
  const style = colour ? { borderColor: colour } : {};

  return (
    <LazyLoadingTrackingList className='questionList' style={style}>
      {questionList.map((question, rowIndex) => {
        const columnProps: GroupQuestionListColumnProps = {
          question,
          alternativeCode,
          preferredAltCodes,
        };

        const key = `${questionGroupId}-${question.universalTracker.getId()}-${rowIndex}`;

        return (
          <Row key={key} onMouseEnter={removeClass} className={'clickable'}>
            {columns.map((column, ix) =>
              React.createElement(column.component, { ...columnProps, key: `col-${ix}-${key}` })
            )}
          </Row>
        );
      })}
    </LazyLoadingTrackingList>
  );
};
